import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
const originalPush = VueRouter.prototype.push
const userPost = localStorage.getItem("post");
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
var homeUrl = ""
if( userPost == 3){
  homeUrl = "/Home/RosterProve"
}else{
  homeUrl = "/Home/HomePage"

}
console.log(homeUrl);
Vue.use(VueRouter)

const routes = [
  {
    path: "",
    redirect: "/dologin"
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录"
    }
  },

  {
    path: "/Home",
    name: 'Home',
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: homeUrl
      },
      {
        path: 'HomePage',
        name: 'HomePage',
        component: () => import('../views/HomePage'),
      },
      {
        path: 'userList',
        name: 'userList',
        component: () => import('../views/user/userList'),
      },
      {
        path: 'SystemLog',
        name: 'SystemLog',
        component: () => import('../views/SystemLog/SystemLog'),
      },
      {
        path: 'assetsType',
        name: 'assetsType',
        component: () => import('../views/assetsType/assetsType'),
      },
      {
        path: 'corporateAssets',
        name: 'corporateAssets',
        component: () => import('../views/corporateAssets/corporateAssets'),
      },
      {
        path: 'cyManufacturer',
        name: 'cyManufacturer',
        component: () => import('../views/cyManufacturer/cyManufacturer'),
      },
      {
        path: 'Consumebs',
        name: 'Consumebs',
        component: () => import('../views/Consumebs/Consumebs'),
      },
      {
        path: 'AccessoryPartType',
        name: 'AccessoryPartType',
        component: () => import('../views/AccessoryPartType/AccessoryPartType'),
      },
      {
        path: 'phoneCard',
        name: 'phoneCard',
        component: () => import('../views/phoneCard/phoneCard'),
      },
      {
        path: 'AccessoryPartAll',
        name: 'AccessoryPartAll',
        component: () => import('../views/AccessoryPartType/AccessoryPartAll'),
      },
      {
        path: 'Roster',
        name: 'Roster',
        component: () => import('../views/Roster/Roster'),
      },
      {
        path: 'RosterContract',
        name: 'RosterContract',
        component: () => import('../views/Roster/RosterContract'),
      },
      {
        path: 'RosterLeave',
        name: 'RosterLeave',
        component: () => import('../views/Roster/RosterLeave'),
      },
      {
        path: 'RosterProve',
        name: 'RosterProve',
        component: () => import('../views/Roster/RosterProve'),
      },
      {
        path: 'AddressBook',
        name: 'AddressBook',
        component: () => import('../views/AddressBook/AddressBook'),
      },
      {
        path: 'DepreciationRule',
        name: 'DepreciationRule',
        component: () => import('../views/DepreciationRule/DepreciationRule'),
      },
      {
        path: 'breakdown',
        name: 'breakdown',
        component: () => import('../views/breakdown/breakdown'),
      },
      {
        path: 'BorrowingReturn',
        name: 'BorrowingReturn',
        component: () => import('../views/BorrowingReturn/BorrowingReturn'),
      },
      {
        path: 'department',
        name: 'department',
        component: () => import('../views/Roster/department'),
      },
      {
        path: 'SysCjCer',
        name: 'SysCjCer',
        component: () => import('../views/cj/SysCjCer'),
      },
      {
        path: 'SysCjProject',
        name: 'SysCjProject',
        component: () => import('../views/cj/SysCjProject'),
      },
      {
        path: 'SysCjProjectMilestone',
        name: 'SysCjProjectMilestone',
        component: () => import('../views/cj/SysCjProjectMilestone'),
      },
      {
        path: 'SysCjProjectSql',
        name: 'SysCjProjectSql',
        component: () => import('../views/cj/SysCjProjectSql'),
      },
      {
        path: 'Attribution',
        name: 'Attribution',
        component: () => import('../views/Roster/Attribution'),
      },
      {
        path: 'social',
        name: 'social',
        component: () => import('../views/social/social'),
      },
      {
        path: 'publicAccumulationFundBill',
        name: 'publicAccumulationFundBill',
        component: () => import('../views/social/publicAccumulationFundBill'),
      },
      {
        path: 'SocialBill',
        name: 'SocialBill',
        component: () => import('../views/social/SocialBill'),
      },
      {
        path: 'standingBook',
        name: 'standingBook',
        component: () => import('../views/social/standingBook'),
      },
      {
        path: 'serviceCharge',
        name: 'serviceCharge',
        component: () => import('../views/social/serviceCharge'),
      },
      {
        path: 'InsuredSubject',
        name: 'InsuredSubject',
        component: () => import('../views/social/InsuredSubject'),
      },
      {
        path: 'authority',
        name: 'authority',
        component: () => import('../views/authority/authority'),
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('../views/authority/role'),
      },
      {
        path: 'AssetsRoster',
        name: 'AssetsRoster',
        component: () => import('../views/corporateAssets/AssetsRoster'),
      },
      {
        path: 'found',
        name: 'found',
        component: () => import('../views/social/found'),
      },
      {
        path: 'errorApi',
        name: 'errorApi',
        component: () => import('../views/cj/errorApi'),
      },
      {
        path: 'checkWork',
        name: 'checkWork',
        component: () => import('../views/checkWork/checkWork'),
      },
      {
        path: 'ApplicationRecord',
        name: 'ApplicationRecord',
        component: () => import('../views/ApplicationRecord/ApplicationRecord'),
      },
      {
        path: 'PaymentChannel',
        name: 'PaymentChannel',
        component: () => import('../views/PurchaseLedger/PaymentChannel'),
      },
      {
        path: 'PurchaseLedger',
        name: 'PurchaseLedger',
        component: () => import('../views/PurchaseLedger/PurchaseLedger'),
      },
      {
        path: 'PublicOption',
        name: 'PublicOption',
        component: () => import('../views/PurchaseLedger/PublicOption'),
      },
      {
        path: 'present',
        name: 'present',
        component: () => import('../views/PurchaseLedger/present'),
      },
      {
        path: 'AccountStatistics',
        name: 'AccountStatistics',
        component: () => import('../views/PurchaseLedger/AccountStatistics'),
      },
      {
        path: 'phoneCardRealName',
        name: 'phoneCardRealName',
        component: () => import('../views/phoneCard/phoneCardRealName'),
      },
      {
        path: 'NailMeeting',
        name: 'NailMeeting',
        component: () => import('../views/NailMeeting/NailMeeting'),
      },
      {
        path: 'meetRoom',
        name: 'meetRoom',
        component: () => import('../views/NailMeeting/meetRoom'),
      },
      {
        path: 'meetRoomschedule',
        name: 'meetRoomschedule',
        component: () => import('../views/NailMeeting/meetRoomschedule'),
      },
      {
        path: 'meetRoomTj',
        name: 'meetRoomTj',
        component: () => import('../views/NailMeeting/meetRoomTj'),
      },
      {
        path: 'workClothes',
        name: 'workClothes',
        component: () => import('../views/workClothes/workClothes'),
      },
      {
        path: 'workClothesOrder',
        name: 'workClothesOrder',
        component: () => import('../views/workClothes/workClothesOrder'),
      },
      {
        path: 'workClothesApplyFor',
        name: 'workClothesApplyFor',
        component: () => import('../views/workClothes/workClothesApplyFor'),
      },
      {
        path: 'officialStamp',
        name: 'officialStamp',
        component: () => import('../views/officialStamp/officialStamp'),
      },
      {
        path: 'AssetsRosterTwo',
        name: 'AssetsRosterTwo',
        component: () => import('../views/corporateAssets/AssetsRoster'),
      },
      {
        path: 'colorWarehouse',
        name: 'colorWarehouse',
        component: () => import('../views/colorWarehouse/colorWarehouse'),
      },
      {
        path: 'httpErrLog',
        name: 'httpErrLog',
        component: () => import('../views/SystemLog/httpErrLog'),
      },
      {
        path: 'telephoneBill',
        name: 'telephoneBill',
        component: () => import('../views/telephoneBill/telephoneBill'),
      },
      {
        path: 'contractMt',
        name: 'contractMt',
        component: () => import('../views/supplierMt/contractMt'),
      },
      {
        path: 'supplierMt',
        name: 'supplierMt',
        component: () => import('../views/supplierMt/supplierMt'),
      },
      {
        path: 'wy',
        name: 'wy',
        component: () => import('../views/supplierMt/wy'),
      },
      {
        path: 'RosterTwo',
        name: 'RosterTwo',
        component: () => import('../views/Roster/RosterTwo'),
      },
      {
        path: 'PersonnelChanges',
        name: 'PersonnelChanges',
        component: () => import('../views/Roster/PersonnelChanges'),
      },
      {
        path: 'NewcomerTraining',
        name: 'NewcomerTraining',
        component: () => import('../views/NewcomerTraining/NewcomerTraining'),
      },
      {
        path: 'DingDingMsg',
        name: 'DingDingMsg',
        component: () => import('../views/SystemLog/DingDingMsg'),
      },
      {
        path: 'projectTask',
        name: 'projectTask',
        component: () => import('../views/cj/projectTask'),
      },
      {
        path: 'manualType',
        name: 'manualType',
        component: () => import('../views/manual/manualType'),
      },
      {
        path: 'manualList',
        name: 'manualList',
        component: () => import('../views/manual/manualList'),
      },
      {
        path: 'manualRecord',
        name: 'manualRecord',
        component: () => import('../views/manual/manualRecord'),
      },
      {
        path: 'YuanGongRecord',
        name: 'YuanGongRecord',
        component: () => import('../views/manual/YuanGongRecord'),
      },
      {
        path: 'CompanyKey',
        name: 'CompanyKey',
        component: () => import('../views/CompanyKey/CompanyKey'),
      },
      {
        path: 'keyBorrowReturn',
        name: 'keyBorrowReturn',
        component: () => import('../views/CompanyKey/keyBorrowReturn'),
      },
        {
        path: 'leaveApplication',
        name: 'leaveApplication',
        component: () => import('../views/DingKaoQin/leaveApplication'),
      },
      {
        path: 'businessTripApply',
        name: 'businessTripApply',
        component: () => import('../views/DingKaoQin/businessTripApply'),
      },
      {
        path: 'overtimeApply',
        name: 'overtimeApply',
        component: () => import('../views/DingKaoQin/overtimeApply'),
      },
      {
        path: 'homeApplication',
        name: 'homeApplication',
        component: () => import('../views/DingKaoQin/homeApplication'),
      },
      {
        path: 'attendanceRecord',
        name: 'attendanceRecord',
        component: () => import('../views/DingKaoQin/attendanceRecord'),
      },
      {
        path: 'vacationApply',
        name: 'vacationApply',
        component: () => import('../views/DingKaoQin/vacationApply'),
      },
      {
        path: 'goOutToApply',
        name: 'goOutToApply',
        component: () => import('../views/DingKaoQin/goOutToApply'),
      },
      {
        path: 'attendanceStatistics',
        name: 'attendanceStatistics',
        component: () => import('../views/DingKaoQin/attendanceStatistics'),
      },
      {
        path: 'fireEquipment',
        name: 'fireEquipment',
        component: () => import('../views/fireEquipment/fireEquipment'),
      },
      {
        path: 'CompanyDormitory',
        name: 'CompanyDormitory',
        component: () => import('../views/CompanyDormitory/CompanyDormitory'),
      },
      {
        path: 'dormApplication',
        name: 'dormApplication',
        component: () => import('../views/dormApplication/dormApplication'),
      },
       {
        path: 'checkoutRoom',
        name: 'checkoutRoom',
        component: () => import('../views/dormApplication/checkoutRoom'),
      },
       {
        path: 'robotMessage',
        name: 'robotMessage',
        component: () => import('../views/robotMessage/robotMessage'),
      },
      
       {
        path: 'phoneNumberBill',
        name: 'phoneNumberBill',
        component: () => import('../views/phoneNumberBill/phoneNumberBill'),
      },
       {
        path: 'phoneNumberBillTj',
        name: 'phoneNumberBillTj',
        component: () => import('../views/phoneNumberBill/phoneNumberBillTj'),
      },
      {
        path: 'databaseBackup',
        name: 'databaseBackup',
        component: () => import('../views/cj/databaseBackup'),
      },
      // {
      //   path: 'BorrowingReturn',
      //   name: 'BorrowingReturn',
      //   component: () => import('../views/BorrowingReturn/BorrowingReturn'),
      // },
    ]
  },
]


const router = new VueRouter({
  routes
})

export default router
